import type { FC } from 'react'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import Modal from 'react-modal'

import Checkbox from 'components/Checkbox'
import { LinkifiedText } from 'components/LinkifiedText'
import Icon from 'components/Icon'
// eslint-disable-next-line no-restricted-imports -- WHY: 伝達事項の画像取得の既存レガシー実装。repositories/ 移行は別チケット
import RestClient, { getAuthHeader } from 'services/RestClient'
// eslint-disable-next-line no-restricted-imports -- WHY: 同上
import { getCheckinAuthHeader } from 'services/RestCheckinClient'
import type { ConfirmationType } from '../type'
import * as S from './styles'

const buildConfig = (isCheckinPage: Boolean = false) => {
  return {
    headers: isCheckinPage ? getCheckinAuthHeader(true) : getAuthHeader(),
    'Content-Type': 'application/octet-stream',
    responseType: 'blob',
  }
}

type Props = {
  isCheckinPage?: Boolean
  confirmations?: ConfirmationType[]
  confirmation?: ConfirmationType
  confirmedIds?: any
  onChangeCheck?: (e: React.ChangeEvent<HTMLInputElement>, item: ConfirmationType) => void
  onClickCheck?: (confirmation: ConfirmationType) => void
  isSp?: boolean
}

const DriverConfirmationItem: FC<Props> = ({
  confirmation,
  confirmedIds,
  onChangeCheck,
  onClickCheck,
  isCheckinPage,
  isSp,
}) => {
  const [loading, setLoading] = useState(false)
  const [fileImg, setFileImg] = useState('')
  const [isShowModalImage, setIsShowModalImage] = useState(false)
  const hasImageConfirmation = _.get(confirmation, 'images[0]', {})

  useEffect(() => {
    ;(async () => {
      const client = new RestClient()
      // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
      if (hasImageConfirmation?.id) {
        setLoading(true)
        client
          .get(
            // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
            `/general-receptions/driver-confirmation-image`,
            // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
            { id: hasImageConfirmation?.id },
            buildConfig(isCheckinPage)
          )
          .then((res) => {
            const file = new Blob([res.data])
            const reader: any = new FileReader()
            reader.readAsDataURL(file)
            reader.onloadend = function () {
              setFileImg(reader.result)
            }
            setLoading(false)
          })
          .catch(() => {
            setLoading(false)
          })
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOpenModalImage = (e: React.MouseEvent<HTMLImageElement>) => {
    e.stopPropagation()
    setIsShowModalImage(true)
  }

  // WHY: SP / PC で画像モーダル(Modal)の JSX が同一なので、行コンテンツだけを isSp で分岐し
  //      Modal は下の return で 1 箇所に集約する(重複解消)
  // SP: テキスト左＋確認チェック右の横並び。重要は赤枠。画像は上/下(aboveTextFlag)
  const content = isSp ? (
    <S.SpItem isImportant={confirmation?.importantFlag}>
      {/* @ts-ignore TypeScript4系移行時に発生した型エラーを回避 */}
      {fileImg && Boolean(hasImageConfirmation?.aboveTextFlag) && (
        <S.ImageContent src={fileImg} alt="image confirmation" onClick={handleOpenModalImage} />
      )}
      <S.SpItemRow>
        <S.SpItemText>
          <S.Pre>
            <LinkifiedText text={confirmation?.confirmation} />
          </S.Pre>
        </S.SpItemText>
        {confirmation?.checkFlag && (
          <S.SpCheckArea>
            <Checkbox
              label=""
              className="d-block mb-1 ml-2"
              checked={confirmedIds?.includes(confirmation?.id || '')}
              disabled={loading}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChangeCheck && onChangeCheck(e, confirmation!)
              }
            />
            <S.SpCheckLabel>
              {confirmedIds?.includes(confirmation?.id || '') ? '確認済' : '確認'}
            </S.SpCheckLabel>
          </S.SpCheckArea>
        )}
      </S.SpItemRow>
      {/* @ts-ignore TypeScript4系移行時に発生した型エラーを回避 */}
      {fileImg && !hasImageConfirmation?.aboveTextFlag && (
        <S.ImageContent src={fileImg} alt="image confirmation" onClick={handleOpenModalImage} />
      )}
    </S.SpItem>
  ) : (
    <S.WrapDriverConfirmation
      isImportant={confirmation?.importantFlag}
      checkFlag={confirmation?.checkFlag}
      onClick={() => (loading ? _.noop : onClickCheck && onClickCheck(confirmation!))}
    >
      {/* @ts-ignore TypeScript4系移行時に発生した型エラーを回避 */}
      {confirmation?.importantFlag && <S.TextImportant>重要!!</S.TextImportant>}
      <S.ContentDriverConfirmation
        // @ts-ignore TypeScript4系移行時に発生した型エラーを回避
        isAboveText={hasImageConfirmation && hasImageConfirmation?.aboveTextFlag}
      >
        {loading ? (
          <S.LoadingCustom isRelative />
        ) : (
          <>
            <div className="wrap-pre-content">
              <S.Pre className="m-1 py-2">
                <LinkifiedText text={confirmation?.confirmation} />
              </S.Pre>
            </div>
            {!_.isEmpty(confirmation?.images) && (
              <S.ImageContent
                src={fileImg}
                alt="image confirmation"
                onClick={handleOpenModalImage}
              />
            )}
          </>
        )}
        <S.CheckboxWrapper>
          <div className="text-center">
            {confirmation?.checkFlag && (
              <Checkbox
                label={confirmedIds?.includes(confirmation?.id || '') ? '確認済' : '確認'}
                checked={confirmedIds?.includes(confirmation?.id || '')}
                disabled={loading}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onChangeCheck && onChangeCheck(e, confirmation)
                }
              />
            )}
          </div>
        </S.CheckboxWrapper>
      </S.ContentDriverConfirmation>
    </S.WrapDriverConfirmation>
  )

  return (
    <>
      {content}
      <Modal
        isOpen={isShowModalImage}
        onRequestClose={() => setIsShowModalImage(false)}
        style={S.CustomStylesModal}
      >
        <S.IconCloseModal onClick={() => setIsShowModalImage(false)}>
          <Icon
            src="/assets/svgs/close-icon-white.svg"
            alt="close modal"
            type="button"
            width={undefined}
            height={undefined}
          />
        </S.IconCloseModal>
        <S.ImageContentModal src={fileImg} alt="image confirmation modal" />
      </Modal>
    </>
  )
}

const DriverConfirmations: FC<Props> = ({
  confirmations = [],
  confirmedIds = [],
  onChangeCheck = _.noop,
  onClickCheck = _.noop,
  isCheckinPage = false,
  isSp = false,
}) => {
  const filteredConfirmations = confirmations?.filter(
    (confirmation: ConfirmationType) => confirmation?.displayFlag
  )

  if (isSp) {
    return (
      <div className="mt-4">
        <S.SpLeadText>
          伝達事項が{filteredConfirmations.length}件あります。
          <br />
          確認をして受付完了してください。
        </S.SpLeadText>
        <S.SpConfirmationList>
          {filteredConfirmations.map((confirmation, i) => (
            <React.Fragment key={confirmation?.id}>
              {/* NOTE: SP は行タップトグルを採らないため onClickCheck は渡さない(未使用) */}
              <DriverConfirmationItem
                isSp
                isCheckinPage={isCheckinPage}
                confirmedIds={confirmedIds}
                confirmation={confirmation}
                onChangeCheck={onChangeCheck}
              />
              {i < filteredConfirmations.length - 1 && <S.SpDivider />}
            </React.Fragment>
          ))}
        </S.SpConfirmationList>
      </div>
    )
  }

  return (
    <div className="mx-auto">
      <div className="text-center mb-3">
        <div className="text-size32 font-weight-bold">ドライバーの皆様へ</div>
        <div>
          伝達事項が{filteredConfirmations.length}件あります。確認をして受付完了してください。
        </div>
      </div>

      <div className="d-flex justify-content-center mt-5">
        {filteredConfirmations.map((confirmation) => (
          <DriverConfirmationItem
            isCheckinPage={isCheckinPage}
            confirmedIds={confirmedIds}
            confirmation={confirmation}
            onChangeCheck={onChangeCheck}
            onClickCheck={onClickCheck}
            key={confirmation?.id}
          />
        ))}
      </div>
    </div>
  )
}

export default DriverConfirmations
